import '../index.css';
var styles = {
  "textInput": "bp_text_input_module_textInput--04959",
  "iconLoading": "bp_text_input_module_iconLoading--04959"
};
export { styles as default };